module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "destination"
    }
  }), _vm._v(": " + _vm._s(_vm.reservation.travel_package_name) + " "), _c('i', {
    staticClass: "fa fa-suitcase pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "padding-bottom": "0",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [_c('p', [_vm._v(_vm._s(_vm.reservation.start_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [_c('p', [_vm._v(_vm._s(_vm.reservation.end_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [_c('p', [_vm._v(_vm._s(_vm.reservation.days))])])]), _vm._v(" "), (_vm.showTourLeader) ? _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_c('entity-text', {
    attrs: {
      "text": "tourLeader"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [(_vm.reservation.tour_leaders && _vm.reservation.tour_leaders.length > 0) ? _c('p', _vm._l((_vm.reservation.tour_leaders), function(tour_leader, key, index) {
    return _c('ul', {
      staticStyle: {
        "list-style": "none"
      }
    }, [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.formatLongName(tour_leader)))])]), _vm._v(" "), _c('li', [_vm._v("Telefoon: " + _vm._s(tour_leader.tel_number ? tour_leader.tel_number : '-'))]), _vm._v(" "), _c('li', [_vm._v("Email: " + _vm._s(tour_leader.email ? tour_leader.email : '-'))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.reservation.tour_leaders && _vm.reservation.tour_leaders.length === 0) ? _c('p', [_vm._v("Geen "), _c('entity-text', {
    attrs: {
      "text": "tourLeader"
    }
  })], 1) : _vm._e()])]) : _vm._e()])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-12 col-sm-12 col-xs-12"
  }, [_c('component-list', {
    attrs: {
      "reservationId": _vm.reservationId
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20015d9f"}!./src/templates/reservations/travel-package.html
// module id = 531
// module chunks = 1